import styled from '@emotion/styled'

const FlexColumn = styled.div`
    display: flex;
    flex-direction: column;
`

export default FlexColumn
